import { authentication, isGfkUser, logger } from '@ecosystem/newron-client-lib'
import { ErrorInfo, InsightErrorType } from 'typings/errorTypes'

export type ProviderCollectionProps = {
  isLive: boolean
  onError: (errorInfo: ErrorInfo) => void
}

type impersonationHeader = {
  'X-Impersonate-Client': string
}

const WAIT_STEP_MS = 100
const WAIT_MAX_TRIES = 20

export const readImpersonationStorage = () => {
  const item = localStorage.getItem('impersonation')
  return item ? JSON.parse(item) : undefined
}

export async function clientToImpersonate(
  collection?: ProviderCollectionProps
): Promise<impersonationHeader | null> {
  const user = authentication.getUser()
  if (!isGfkUser(user?.userId)) {
    return null
  }

  let tries = 0
  let storage = readImpersonationStorage()
  while (!storage && tries < WAIT_MAX_TRIES) {
    tries++
    await new Promise((resolve) => setTimeout(resolve, WAIT_STEP_MS))
    storage = readImpersonationStorage()
  }

  const clientId = storage?.client_id
  const clientUserGroupIds = storage?.client_user_group_ids
  if (clientId && clientUserGroupIds) {
    return {
      'X-Impersonate-Client': JSON.stringify({
        client_id: clientId,
        client_name: storage?.client_name,
        client_user_group_ids: clientUserGroupIds,
      }),
    }
  }

  const loggerMessage = 'Failed to load impersonation data in time.'
  const userMessage =
    'Your subscription does not allow you to see any data, please contact your GfK representative.'
  collection?.onError &&
    collection.onError({
      errorType: InsightErrorType.SUBSCRIPTION_ERROR,
      loggerMessage,
      userMessage,
    })
  logger.error(new Error(loggerMessage))
  return null
}
